
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/blog-posts/post-testing-slump-activities-keep-students-learning",
      function () {
        return require("private-next-pages/c/blog-posts/post-testing-slump-activities-keep-students-learning.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/blog-posts/post-testing-slump-activities-keep-students-learning"])
      });
    }
  